// components/payments/BankProcessModal.tsx
import React from 'react';
import { Modal, Button, Alert } from 'antd';
import { formatAmount } from "@/components/common/utils/money";

interface BankProcessStep {
    order: number;
    instruction: string;
    description: string;
}

interface BankProcessAdditionalInfo {
    supportContact: string;
    notes: string;
}

interface BankProcess {
    steps: BankProcessStep[];
    additionalInfo: BankProcessAdditionalInfo;
}

interface BankProcessModalProps {
    open: boolean;
    onClose: () => void;
    processDefinition?: string;
    amount?: string;
    paymentReference?: string;
}

export const BankProcessModal: React.FC<BankProcessModalProps> = ({
                                                                      open,
                                                                      onClose,
                                                                      processDefinition,
                                                                      amount,
                                                                      paymentReference
                                                                  }) => {
    if (!processDefinition) return null;

    const process: BankProcess = JSON.parse(processDefinition);

    return (
        <Modal
            title="Payment Instructions"
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    Close
                </Button>
            ]}
        >
            <div className="space-y-4">
                <Alert
                    message="Payment Details"
                    description={
                        <div>
                            <p>Amount: {formatAmount(Number(amount))} TZS</p>
                            <p>Reference: {paymentReference}</p>
                        </div>
                    }
                    type="info"
                    showIcon
                />

                {process.steps.map((step) => (
                    <div key={step.order} className="border-b pb-4">
                        <h3 className="font-bold">{`${step.order}. ${step.instruction}`}</h3>
                        <p className="text-gray-600">{step.description}</p>
                    </div>
                ))}

                {process.additionalInfo && (
                    <Alert
                        message="Additional Information"
                        description={
                            <div>
                                <p>Support Contact: {process.additionalInfo.supportContact}</p>
                                <p>{process.additionalInfo.notes}</p>
                            </div>
                        }
                        type="warning"
                        showIcon
                    />
                )}
            </div>
        </Modal>
    );
};